import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import zhLocale from "./locales/zh.json";
import zhTWLocale from "./locales/zh-TW.json";
import enLocale from "./locales/en.json";
import jaLocale from "./locales/ja.json";
import esLocale from "./locales/es.json";
import ruLocale from "./locales/ru.json";
import msLocale from "./locales/ms.json";
import arLocale from "./locales/ar.json";
import koLocale from "./locales/ko.json";
import frLocale from "./locales/fr.json";
import thLocale from "./locales/th.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enLocale },
      zh: { translation: zhLocale },
      'zh-TW': { translation: zhTWLocale },
      es: { translation: esLocale },
      fr: { translation: frLocale },
      ru: { translation: ruLocale },
      ar: { translation: arLocale },
      ja: { translation: jaLocale },
      ko: { translation: koLocale },
      ms: { translation: msLocale },
      th: { translation: thLocale }
    },
    lng: "en", // 设置默认语言为英文
    fallbackLng: "en",
    debug: false,
    supportedLngs: ['en', 'zh', 'zh-TW', 'es', 'fr', 'ru', 'ar', 'ja', 'ko', 'ms', 'th'],
    detection: {
      order: ['localStorage'], // 只从localStorage检测，移除navigator和htmlTag
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false,
    },
  });

// 确保首次访问时使用英文
if (!localStorage.getItem('i18nextLng')) {
  i18n.changeLanguage('en');
}

export const languages = {
  en: 'English',
  zh: '简体中文',
  'zh-TW': '繁體中文',
  es: 'Español',
  fr: 'Français',
  ru: 'Русский',
  ar: 'العربية',
  ja: '日本語',
  ko: '한국어',
  ms: 'Bahasa Melayu',
  th: 'ไทย'
};

export default i18n; 